import Vue from 'vue'

export default {
  apiPrefix: '/api/v2/sites',
  getSiteContacts: function ({siteId}) {
    let apiDetailPath = this.apiPrefix + `/${siteId}/contacts`
    return Vue.http.get(Vue.env.apiPath + apiDetailPath, Vue.auth.getBearerHeader())
  },
  getSiteContact: function ({siteId, contactId}) {
    let apiDetailPath = this.apiPrefix + `/${siteId}/contacts/${contactId}`
    return Vue.http.get(Vue.env.apiPath + apiDetailPath, Vue.auth.getBearerHeader())
  }
}
